import { Button, DialogActions } from '@fluentui/react-components';

import { useTelemetryContext } from '../../../../../../telemetry/components/TelemetryPanel/TelemetryPanel.js';
import type { UserBiActionOptions } from '../../../../../../telemetry/hooks/useUserBi/useUserBi.interface.js';
import {
  ActionOutcome,
  ActionScenarioType,
} from '../../../../../../telemetry/userbi.js';

export interface AnnotationConfirmationActionsProps {
  actionScenario: UserBiActionOptions['actionScenario'];
  cancelLabel: string;
  confirmLabel: string;
  pending: boolean;
  confirmDisabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function AnnotationConfirmationActions({
  actionScenario,
  cancelLabel,
  confirmLabel,
  pending,
  confirmDisabled,
  onCancel,
  onConfirm,
}: AnnotationConfirmationActionsProps) {
  const { recordPanelAction } = useTelemetryContext();
  return (
    <DialogActions>
      <Button
        disabled={pending}
        onClick={() => {
          recordPanelAction({
            actionScenario,
            actionScenarioType: ActionScenarioType.CloseDialog,
            actionGesture: 'click',
          });
          onCancel();
        }}
      >
        {cancelLabel}
      </Button>
      <Button
        appearance="primary"
        disabled={pending || confirmDisabled}
        onClick={() => {
          recordPanelAction({
            actionScenario,
            actionScenarioType: ActionScenarioType.Submit,
            actionGesture: 'click',
            actionOutcome: ActionOutcome.Requested,
          });
          onConfirm();
        }}
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  );
}
